import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setStyle, clearStyle } from "./styleSlice"; // ⭐ Import setStyle action
import { getPaymentLinkHeaders } from "../../utils/paymentLinkHeaders"; // Import secure headers utility
import { parseApiError } from "../../utils/paymentLinkErrorHandler"; // Import error handler


const BASE_URL = process.env.REACT_APP_API_URL;

// Async thunk untuk fetch data pembayaran
export const fetchPaymentData = createAsyncThunk(
  "payment/fetchPaymentData",
  async (reffNo, { rejectWithValue, dispatch }) => { // ⭐ Tambahkan dispatch
    try {
      const response = await fetch(`${BASE_URL}/api/payment-link`, {
        method: "POST",
        headers: getPaymentLinkHeaders(),
        body: JSON.stringify({ reff_no: reffNo }),
      });

      if (!response.ok) {
        console.log('error:', response);
        // Parse error to get error_code
        const errorData = await parseApiError(response);
        return rejectWithValue({
          message: errorData.message,
          errorCode: errorData.errorCode,
          httpStatus: errorData.httpStatus,
        });
      }

      const result = await response.json();
      if (!result.success || !result.data) {
        return rejectWithValue({
          message: "Transaction not found or Expired",
          errorCode: result.error_code || null,
          httpStatus: result.code || 404,
        });
      }

      // ⭐ NEW: Dispatch style ke styleSlice jika ada
      if(process.env.REACT_APP_DEBUG){
        console.log('ini cuy', result.data.PaymentLinkMerchantStyle);
      }

      if (result.data.PaymentLinkMerchantStyle) {
        dispatch(setStyle(result.data.PaymentLinkMerchantStyle));
      }
      else{
        dispatch(clearStyle());
      }

      // Return paymentLink data saja
      return result.data.paymentLink || result.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message || "An error occurred",
        errorCode: null,
        httpStatus: 500,
      });
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    errorCode: null,
    httpStatus: null,
  },
  reducers: {
    clearPaymentData: (state) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.errorCode = null;
      state.httpStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorCode = null;
        state.httpStatus = null;
      })
      .addCase(fetchPaymentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
        state.errorCode = null;
        state.httpStatus = null;
      })
      .addCase(fetchPaymentData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "An error occurred";
        state.errorCode = action.payload?.errorCode || null;
        state.httpStatus = action.payload?.httpStatus || null;
      });
  },
});

export const { clearPaymentData } = paymentSlice.actions;
export default paymentSlice.reducer;